import { TariffCard } from './components/tariff-card'
import { TariffFeature } from './types/tariff.types'

export const TariffsPage = () => {
  const freeTariffFeatures: TariffFeature[] = [
    { text: 'до 5 пользователей', included: true, hasTooltip: true, tooltipText: 'Максимальное количество участников' },
    { text: '0 модулей', included: false },
    { text: 'до 3 пространств', included: true },
    { text: 'до 5 уникальных досок', included: true },
    { text: 'до 1 чек-листа на карточку', included: true },
    { text: 'до 5 пользовательских полей', included: true },
    { text: 'до 5 гостей', included: true },
  ]

  const startTariffFeatures: TariffFeature[] = [
    { text: 'до 15 пользователей', included: true, hasTooltip: true, tooltipText: 'Для небольших команд' },
    { text: 'модули Скрам и Канбан', included: true },
    { text: 'до 10 пространств', included: true },
    { text: 'до 10 уникальных досок', included: true },
    { text: 'до 15 пользовательских полей', included: true },
    { text: 'до 15 гостей', included: true },
    { text: 'до 5 автоматизаций', included: true },
    { text: 'до 5 ограничений', included: true },
  ]

  return (
    <div className="">
      <div className="d-flex">
        <div>
          <TariffCard
            buttonText="Подробнее"
            buttonType="default"
            description="Для личной эффективности, без ограничения по сроку"
            features={freeTariffFeatures}
            footerText={`Документы и базы знаний\nИнтеграции Email, Telegram`}
            isHighlighted={false}
            price="0 ₽"
            subtitle="мес."
            title="Бесплатный"
          />
        </div>

        <div className="ml-2">
          <TariffCard
            buttonText="Рассчитать стоимость"
            buttonType="default"
            description="Для небольших команд, которым нужна прозрачность"
            features={startTariffFeatures}
            footerText={`Одна доска на нескольких\nпространствах, отчеты`}
            isHighlighted={false}
            price="185 ₽"
            subtitle="мес."
            title="Старт"
          />
        </div>
      </div>
    </div>
  )
}
